import React from 'react';
import Layout from '@rezdy/components/Layout/DarkCentered';
import { Article, Aside, Body } from '@rezdy/components/Layout/Article/Styled';
import SocialLogin from '../SocialLogin';
import socialAuthorize from '../../actions/socialAuthorize';
import { TIdentityProvider } from '../../services/auth';
import Button from '@rezdy/components/Button';
import TextStyle from '@rezdy/components/TextStyle';
import Icon from '@rezdy/components/Icon';
import { Title, Color } from './Styled';
import Grid from '@rezdy/components/Grid';
import Card from './Layout/Card';
import routing from '../../services/routing';
import routes from '../../constants/routes';
import SecondaryAction from '../Layout/SecondaryAction';
import { blue, rowGap } from '../../constants/theme';
import { SignupType } from '../../model/SignupType';
import { withTranslation, WithTranslation } from 'react-i18next';
import pendo from '../../services/pendo';

const CardItem = (props: any) => {
    return (
        <Grid.Container cols="20px 1fr" colGap="8px" placeItems="start">
            <Grid.Cell>
                <div style={{ paddingTop: 3 }}>
                    <Icon name="round-check" size="large" color={blue} />
                </div>
            </Grid.Cell>
            <Grid.Cell alignSelf="start">
                <TextStyle size="small">{props.children}</TextStyle>
            </Grid.Cell>
        </Grid.Container>
    );
};

interface ISignupSelectProps extends WithTranslation {
    signupType?: SignupType;
}
/**
 * @deprecated
 */
class SignUpSelect extends React.PureComponent<ISignupSelectProps, {}> {
    card = {
        photo: '/img/canoo-girl.jpg',
    };

    onHandleSocialLogin = async (provider: TIdentityProvider) => {
        try {
            // redirect uri needs to be custom ui
            await socialAuthorize(
                provider,
                () => pendo.trackEvent(pendo.buildAnonymousVisitor(), 'Old Sign Up - Google Sign Up Clicked'),
                () => pendo.trackEvent(pendo.buildAnonymousVisitor(), 'Old Sign Up - Redirected To Google')
            );
        } catch (error) {
            this.setState({
                isDirty: true,
                isLoading: false,
                message: error.message,
            });
        }
    };

    onSelectEmail = () => {
        routing.push(routes.SIGN_UP_WITH_EMAIL);
    };

    renderBookingSoftwareTitle = () => {
        return (
            <TextStyle align="center" as="div" style={{ margin: '0px auto' }}>
                <Title style={{ maxWidth: '12ch' }}>
                    Try Rezdy <Color color={blue}>free</Color> for 21 days
                </Title>
                <TextStyle as="p">No credit card required</TextStyle>
            </TextStyle>
        );
    };

    renderMarketplaceTitle = () => {
        return (
            <TextStyle align="center" as="div" style={{ margin: '0px auto' }}>
                <Title style={{ maxWidth: '12ch' }}>
                    <Color color={blue}>Welcome</Color> to
                </Title>
                <Title style={{ maxWidth: '16ch' }}>Rezdy Marketplace</Title>
                <TextStyle as="p">Create your profile</TextStyle>
            </TextStyle>
        );
    };

    renderTitle = () => {
        const { signupType } = this.props;
        switch (signupType) {
            case SignupType.REZDY_BOOKING_SOFTWARE:
                return this.renderBookingSoftwareTitle();
            case SignupType.REZDY_MARKETPLACE:
                return this.renderMarketplaceTitle();
            default:
                return this.renderBookingSoftwareTitle();
        }
    };

    renderForm = () => {
        return (
            <Grid.Container rowGap={rowGap} style={{ maxWidth: 400, margin: 'auto' }}>
                {this.renderTitle()}
                <Grid.Container rowGap>
                    <SocialLogin
                        provider="Google"
                        handleClick={this.onHandleSocialLogin}
                        name="google-signup"
                        {...this.props}
                    />
                    <Button action="primary" width="100%" onClick={this.onSelectEmail} tight name="email-signup">
                        Get Started with Email
                    </Button>
                </Grid.Container>
            </Grid.Container>
        );
    };

    renderBookingSoftwareCard = () => {
        return (
            <Card photo={this.card.photo}>
                <Grid.Container rowGap="8px">
                    <CardItem>
                        <TextStyle size="small">Add booking functionality to your website</TextStyle>
                    </CardItem>
                    <CardItem>
                        <TextStyle size="small">
                            Access Rezdy Channel Manager to grow your distribution network
                        </TextStyle>
                    </CardItem>
                    <CardItem>
                        <TextStyle size="small">Resell other operators, upsell and earn commissions</TextStyle>
                    </CardItem>
                    <CardItem>
                        <TextStyle size="small">Guides and tutorials to help you set up</TextStyle>
                    </CardItem>
                    <CardItem>
                        <TextStyle size="small">Customer support 24/7</TextStyle>
                    </CardItem>
                </Grid.Container>
            </Card>
        );
    };

    renderMarketplaceCard = () => {
        return (
            <Card photo={this.card.photo}>
                <Grid.Container rowGap="8px">
                    <CardItem>Connect your booking platform to our wide range of resellers</CardItem>
                    <CardItem>Share your price and availability with resellers</CardItem>
                    <CardItem>Reseller bookings are automatically sent to your booking platform</CardItem>
                </Grid.Container>
            </Card>
        );
    };

    renderCard = () => {
        const { signupType } = this.props;
        switch (signupType) {
            case SignupType.REZDY_BOOKING_SOFTWARE:
                return this.renderBookingSoftwareCard();
            case SignupType.REZDY_MARKETPLACE:
                return this.renderMarketplaceCard();
            default:
                return this.renderBookingSoftwareCard();
        }
    };

    render() {
        return (
            <Layout secondaryAction={<SecondaryAction />}>
                <Article>
                    <Body>{this.renderForm()}</Body>
                    <Aside>{this.renderCard()}</Aside>
                </Article>
            </Layout>
        );
    }
}

export default withTranslation()(SignUpSelect);
